import React from 'react'
import { appendVisualizerEntry } from '../../vendor/folia-src/components/visualizer/registry'
import { JizuraSettingsPanel } from './JizuraSettings'

const JizuraVisualizer = React.lazy(() => import('./JizuraVisualizer'))

// Use Folia's existing contribution channel; preserve its built-in mode list.
appendVisualizerEntry({
  mode: 'mod:musey:jizura',
  order: 0,
  labelKey: 'ui.visualizerJizura',
  labelFallback: 'JIZURA',
  previewSeed: 'jizura',
  previewStartOffset: 0,
  tuningKind: 'none',
  render: (props) => <JizuraVisualizer {...props} />,
  renderSettingsPanel: () => <JizuraSettingsPanel />,
})
